export default __webpack_public_path__ + "media/images/work_with_us/team-pic-4-4bcb531b829375e06b3422284e196690.png";